// src/views/Offer/Offer.js
import React, { useContext, useState, useMemo } from "react";
import { Helmet } from "react-helmet";
import DataTable from "../../components/DataTable/DataTable";
import { AuthContext } from "../../context/AuthContext";
import { fetchInternalPackages } from "../../services/packageService";

export default function Offer() {
  const { token } = useContext(AuthContext);

  const columns = [
    { key: "id", label: "ID" },
    { key: "name", label: "Package Name" },
    { key: "price", label: "Price" },
    { key: "gigabytes", label: "GB" },
    { key: "duration", label: "Duration (days)" },
    { key: "currency", label: "Currency" },
    { key: "country_id", label: "Country" },
    { key: "region_id", label: "Region" },
  ];

  const optionalColumns = [
    { key: "description", label: "Description" },

    { key: "top_up_available", label: "Top-Up" },
  ];

  const sortOptions = [
    { value: "id", label: "ID" },
    { value: "name", label: "Name" },
    { value: "price", label: "Price" },
    { value: "gigabytes", label: "GB" },
    { value: "duration", label: "Duration" },
  ];

  const filterDefinitions = [
    { key: "name", type: "text" },
    { key: "description", type: "text" },
    { key: "price", type: "minmax" },
    { key: "gigabytes", type: "minmax" },
    { key: "duration", type: "minmax" },
    {
      key: "currency",
      type: "select",
      options: [
        { value: "USD", label: "USD" },
        { value: "EUR", label: "EUR" },
        { value: "GBP", label: "GBP" },
        { value: "JPY", label: "JPY" },
        { value: "AUD", label: "AUD" },
        { value: "CAD", label: "CAD" },
        { value: "CHF", label: "CHF" },
        { value: "CNY", label: "CNY" },
        { value: "SGD", label: "SGD" },
        { value: "NZD", label: "NZD" },
      ],
    },
    {
      key: "top_up_available",
      type: "select",
      options: [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
      ],
    },
    { key: "country_id", type: "text" },
    { key: "region_id", type: "text" },
  ];

  // --- Custom renderers ---
  const customRenderers = {
    price: (item) => (item.price !== null ? item.price.toFixed(2) : "-"),
    gigabytes: (item) => (item.gigabytes === -1 ? "Unlimited" : item.gigabytes),
    top_up_available: (item) => (item.top_up_available ? "Yes" : "No"),
  };

  return (
    <main className="esim-stats-page">
      <Helmet>
        <title>GlobTel eSIM - Offer Packages</title>
      </Helmet>

      <header className="partner-offers__hero">
        <h1>Offer Packages</h1>
        <p className="partner-offers__lead">
          View and manage internal eSIM packages.
        </p>
      </header>

      <DataTable
        fetchDataFunction={fetchInternalPackages}
        columns={columns}
        optionalColumns={optionalColumns}
        sortOptions={sortOptions}
        filterDefinitions={filterDefinitions}
        defaultSortBy="name"
        itemKey="id"
        customRenderers={customRenderers}
        showCheckboxes={false}
        storageKey="offerTableFilters"
      />
    </main>
  );
}
